import ApiService from "../../services/ApiService"
import { setError } from "./uxAction"

export function loginAsAdmin({ email, password }, callback) {
    return async(dispatch) => {
        try {
            const resp = await ApiService.invokePost(process.env.REACT_APP_API_URL + "/admin/api/authentication/signInAsAdmin", {
                email, password
            })

            if (resp.status >= 400) 
                dispatch(setError(resp.data.errors))

            callback(resp.data)
        } catch (e) {}
    }
}
